var _circle, _circle2, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLpBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.083,
    cy: 36.6162,
    r: 35.6885,
    fill: "url(#paint0_linear_1170_10530)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.083,
    cy: 36.6162,
    r: 33.9165,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 3.5439
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.3807 46.2695C51.2596 47.207 51.2596 48.6719 50.3807 49.6094C49.4432 50.4883 47.9784 50.4883 47.0409 49.6094L40.0682 42.5781C37.6659 44.1602 34.7362 44.9805 31.5721 44.5117C26.1815 43.8086 21.8455 39.4141 21.1424 34.082C20.1463 26.0547 26.826 19.375 34.8534 20.3711C40.1854 21.0742 44.5799 25.4102 45.3416 30.8008C45.7518 33.9648 44.9315 36.8945 43.3494 39.2383L50.3807 46.2695ZM37.9588 33.8477C38.7205 33.8477 39.3651 33.2617 39.3651 32.4414C39.3651 31.6797 38.7205 31.0352 37.9002 31.0352H34.619V27.7539C34.619 26.9922 33.9159 26.3477 33.2127 26.3477C32.451 26.3477 31.8651 26.9922 31.8651 27.7539V31.0352H28.5252C27.7635 31.0352 27.1776 31.6797 27.1776 32.4414C27.1776 33.2617 27.7635 33.8477 28.5252 33.8477H31.8651V37.1289C31.8651 37.9492 32.451 38.5352 33.2713 38.5352C33.9744 38.5352 34.619 37.9492 34.619 37.1289V33.8477H37.9588Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1170_10530",
    x1: 23.696,
    y1: 72.3046,
    x2: 71.7714,
    y2: 24.2292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#622FF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44A0F8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLpBlue);
export default __webpack_public_path__ + "static/media/lpBlue.f03766959f069660631696a02f050c00.svg";
export { ForwardRef as ReactComponent };